<template>
  <div class="bg-white shadow-sm rounded overflow-hidden">
    <div
      v-if="$slots.banner"
      class="bg-primary-weak text-primary-default px-8 py-1 text-center"
    >
      <TypeOverline variant="x-small-tight">
        <slot name="banner" />
      </TypeOverline>
    </div>

    <div class="p-8">
      <slot />
    </div>
  </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { TypeOverline } from '@bambeehr/pollen';

// TODO: This is a stopgap until Pollen is updated. Please deprecate ASAP
export default defineComponent({
  name: 'BaseCard',
  components: { TypeOverline },
  props: {
    header: {
      type: String,
      default: '',
    },
  },
  setup(props, { slots }) {
    return {
      slots,
    };
  },
});
</script>
